import styled from 'styled-components';
import { SPACING } from '../../../constants/theme';

export const HeroImage = styled.div`
  margin: 0 auto ${SPACING.xxl};
  text-align: center;

  img {
    width: 58%;
    max-width: 320px;
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};

  @media (min-width: 576px) {
    flex-direction: row;

    & > * {
      flex: 1;
    }
  }
`;
